var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","position":"relative"},attrs:{"id":"tc_play_warp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }